(function ($) {
  $.fontSpy = function (fontFamilyName, conf) {
    var $html = $('html');
    var $body = $('body');

    // Throw error if fontName is not a string or not is left as an empty string
    if (typeof fontFamilyName !== 'string' || fontFamilyName === '') {
      return;
    }

    if (/\s/.test(fontFamilyName)) {
      fontFamilyName = '\'' + fontFamilyName + '\'';
    }

    var defaults = {
      font: fontFamilyName.replace(/['"]+/g, '\''), // Replace '' with '
      fontClass: fontFamilyName.toLowerCase().replace(/\s/g, ''),
      success: function () {
      },
      failure: function () {
      },
      testFont: 'Nunito',
      testFontCallback: 'Lato',
      testString: 'QW@HhsXJ',
      glyphs: '',
      delay: 50,
      timeOut: 10000,
      callback: $.noop,
      style: 'normal'
    };

    if (!conf.success) {
      conf.success = conf.onLoad;
    }

    var config = $.extend(defaults, conf);

    var createTester = function (testString, glyphs, fontFamily, style) {
      var $tester = $('<span>' + testString + glyphs + '</span>')
        .css('position', 'absolute')
        .css('top', '-9999px')
        .css('left', '-9999px')
        .css('visibility', 'hidden')
        .css('fontFamily', fontFamily)
        .css('fontSize', '250px')
        .css('fontStyle', style);
      $body.append($tester);
      return $tester;
    };

    var $fontTester = createTester(config.testString, config.glyphs, config.font.replace(/['"]+/g, '\''), config.style);
    var fontWidth = conf.node ? conf.node.getBBox().width : $fontTester.outerWidth();

    var failure = function () {
      $html.addClass('no-' + config.fontClass);
      if (config && config.failure) {
        config.failure();
      }
      config.callback(new Error('FontSpy timeout'));
      $fontTester.remove();
    };

    var success = function () {
      config.callback();
      $html.addClass(config.fontClass);
      if (config && config.success) {
        config.success();
      }
      $fontTester.remove();
    };

    var retry = function () {
      setTimeout(checkFont, config.delay);
      config.timeOut = config.timeOut - config.delay;
    };

    var checkFont = function () {
      var loadedFontWidth = conf.node ? conf.node.getBBox().width : $fontTester.outerWidth();

      if (fontWidth !== loadedFontWidth) {
        success();
      } else if (config.timeOut < 0) {
        failure();
      } else {
        retry();
      }
    };

    checkFont();
  };

  $.fn.fontSpy = function (config) {
    return this.each(function () {
      if (undefined == $(this).data('fontSpy')) {
        var plugin = new $.fontSpy(this, config);
        $(this).data('fontSpy', plugin);
      }
    });
  };

  // use this transport for "binary" data type
  $.ajaxTransport('+binary', function (options, originalOptions, jqXHR) {
		// check for conditions and support for blob / arraybuffer response type
    if (window.FormData && ((options.dataType && (options.dataType == 'binary')) || (options.data && ((window.ArrayBuffer && options.data instanceof ArrayBuffer) || (window.Blob && options.data instanceof Blob)))))		{
      return {
				// create new XMLHttpRequest
        send: function (headers, callback) {
					// setup all variables
          var xhr = new XMLHttpRequest(),
            url = options.url,
            type = options.type,
            async = options.async || true,
					// blob or arraybuffer. Default is blob
            dataType = options.responseType || 'blob',
            data = options.data || null,
            username = options.username || null,
            password = options.password || null;

          xhr.addEventListener('load', function () {
            var data = {};
            data[options.dataType] = xhr.response;
						// make callback and send data
            callback(xhr.status, xhr.statusText, data, xhr.getAllResponseHeaders());
          });

          xhr.open(type, url, async, username, password);

					// setup custom headers
          for (var i in headers) {
            xhr.setRequestHeader(i, headers[i]);
          }

          xhr.responseType = dataType;
          xhr.send(data);
        },
        abort: function () {
          jqXHR.abort();
        }
      };
    }
  });

  $.extend({
    coalesce: function () {
      for (var i in arguments) {
        if (arguments[i] !== null && arguments[i] !== undefined) {
          return arguments[i];
        }
      }
      return null;
    },

    checkFont: function (font, callback, options) {
      options = $.extend({
        'url': '//fonts.googleapis.com/css?family='
      }, options);
      callback = callback || function () {
      };

      fontSpy(font, {
        success: function () {
          callback();
        },
        failure: function () {
          var link = document.createElement('link');

          link.setAttribute('rel', 'stylesheet');
          link.setAttribute('type', 'text/css');
          link.setAttribute('href', options.url + font);

          document.getElementsByTagName('head')[0].appendChild(link);

          $(document).ready(function (e) {
            fontSpy(font, {
              success: function () {
                callback();
              },
              failure: function () {
                alert('Fail to load font - ' + font);
              }
            });
          });
        }
      });
    }
  });

  $.expr[':'].contains = $.expr.createPseudo(function (arg) {
    return function (elem) {
      return $(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0;
    };
  });

  $.fn.extend({
    swapWith: function (to) {
      return this.each(function () {
        var copy_to = $(to).clone(true);
        var copy_from = $(this).clone(true);
        $(to).replaceWith(copy_from);
        $(this).replaceWith(copy_to);
      });
    },

    removeAttributes: function () {
      return this.each(function () {
        var attributes = $.map(this.attributes, function (item) {
          return item.name;
        });
        var img = $(this);
        $.each(attributes, function (i, item) {
          img.removeAttr(item);
        });
      });
    },

    removeClassWild: function (mask) {
      return this.removeClass(function (index, cls) {
        var re = mask.replace(/\*/g, '\\S+');
        return (cls.match(new RegExp('\\b' + re + '', 'g')) || []).join(' ');
      });
    },

    callback: function (func) {
      return this.each(function (e) {
        func();
      });
    },

    destroyThumb: function (options) {
      return this.each(function (e) {
        $(this).find('.thumbnail-wrapper').remove();
      });
    },

    initDragable: function (options) {
      var defaults = {
        callback: {
          click: $.noop,
          mousedown: $.noop,
          mousemove: $.noop,
          mouseup: $.noop
        }
      };
      options = $.extend(defaults, options);

			// var touchTimeout = null;
			// var touchTime = 500;
			// var touch = false;
      var elem = null;
      var outline = '2px solid #ffdd17';

      function mouseDown (event)			{
        elem = this;

        var $elem = $(this);
        var roundingRect = $elem.get(0).getBoundingClientRect();
        var $draggableClone = createDraggableClone();

        uppdateDraggableCloneDataPosition();
        bindDragDrop();

        options.callback.mousedown && options.callback.mousedown($draggableClone.get(0), event);

        function createDraggableClone () {
          $draggableClone = $elem.clone(true).off();

          $('#draggingObject').remove();

          $draggableClone.attr('id', 'draggingObject');
          $draggableClone.css('position', 'absolute');
          $draggableClone.css('left', roundingRect.left);
          $draggableClone.css('top', roundingRect.top);
          $draggableClone.css('width', roundingRect.width);
          $draggableClone.css('height', roundingRect.height);
          $draggableClone.css('z-index', 5000);
          $draggableClone.css('opacity', '0');
          $draggableClone.find('a').css('color', $elem.css('color'));

          $draggableClone.find('.tooltip').remove();

          $draggableClone.find('svg *').each(function () {
            var id = $(this).attr('id');
            id && $(this).attr('id', 'clone-' + id);
          });

          $('body').append($draggableClone);

          return $draggableClone;
        }

        function uppdateDraggableCloneDataPosition () {
          var cursorPosition = getCursorPosition(event);

          $draggableClone.data('offset', {
            x: (cursorPosition.x - roundingRect.left) / roundingRect.width,
            y: (cursorPosition.y - roundingRect.top) / roundingRect.height
          });
        }

        function bindDragDrop () {
          $(window).unbind('mousemove touchmove', mouseMove);
          $(window).unbind('mouseup touchend touchcancel', mouseUp);
          $(window).on('mousemove touchmove', mouseMove);
          $(window).on('mouseup touchend touchcancel', mouseUp);
        }
      }

      function mouseMove (event)			{
        $('#draggingObject').length && _.defer(processDraggable);

        function processDraggable () {
          var $draggableClone = $('#draggingObject');
          if (!$('#draggingObject').length) return;

          var roundingRect = $(elem).get(0).getBoundingClientRect();
          var unsnappedPosition = getUnsnappedPosition();

          var dx = Math.abs(unsnappedPosition.x - roundingRect.left);
          var dy = Math.abs(unsnappedPosition.y - roundingRect.top);
          var distance = Math.round(Math.sqrt(dx * dx + dy * dy));

          processPosition();
          processScale();

          dx > 122.5 && event.preventDefault();
          distance > 10 && $draggableClone.data('dragging', true);
          options.callback.mousemove && options.callback.mousemove($draggableClone.get(0), event);

          function getUnsnappedPosition () {
            var offset = $draggableClone.data('offset');
            var cursorPosition = getCursorPosition(event);

            return {
              x: cursorPosition.x - (roundingRect.width * offset.x),
              y: cursorPosition.y - (roundingRect.height * offset.y)
            };
          }

          function processPosition () {
            var isYSnaped = dx < 122.5;
            var isXSnaped = distance < 80;

            var mouseX = isXSnaped
							? roundingRect.left
							: unsnappedPosition.x;

            var mouseY = isYSnaped
							? roundingRect.top
							: unsnappedPosition.y;

            $draggableClone.css('left', mouseX);
            $draggableClone.css('top', mouseY);

            $draggableClone.css('opacity', isXSnaped && isYSnaped ? '0' : '1');
          }

          function processScale () {
            var minimumScaleDistance = 130;
            var maximumScaleDistance = 300;

            var maxScale = 2;
            var multi = 1;

            if (distance > minimumScaleDistance) {
              multi += (distance - minimumScaleDistance) / (maximumScaleDistance - minimumScaleDistance);

              if (multi > maxScale)								{
                multi = maxScale;
              }
            }

            $draggableClone.css('transform', 'scale(' + multi + ')');
          }
        }
      }

      function mouseUp (event)			{
        event.preventDefault();

        var $draggableClone = $('#draggingObject');
        var offset = $('#canvas-panel').offset();

        if ($draggableClone.length)				{
          var cursorPosition = getCursorPosition(event);

          if (cursorPosition.x > offset.left) {
            if (options.callback.mouseup) options.callback.mouseup($draggableClone.get(0), event);
          } else {
            if ($draggableClone.data('dragging')) {
							// Dragging fail
            } else {
							// Click
              if (options.callback.click) options.callback.click($draggableClone.get(0), event);
            }
          }

          $(elem).css('outline', 'none');
          $draggableClone.remove();

          $(window).unbind('mousemove touchmove', mouseMove);
          $(window).unbind('mouseup touchend', mouseUp);
        }
      }

      function getCursorPosition (event) {
        if (event.type.indexOf('touch') === 0)				{
          var retval = {
            x: event.originalEvent.changedTouches[0].clientX,
            y: event.originalEvent.changedTouches[0].clientY
          };

          event.clientX = retval.x;
          event.clientY = retval.y;

          return retval;
        }

        return {
          x: event.clientX,
          y: event.clientY
        };
      }

      return this.each(function (e) {
        $(this).unbind('mousedown touchstart');
        $(this).on('mousedown touchstart', mouseDown);
      });
    },

    addThumb: function (options) {
      var defaults = {
        itemSelector: '.thumbnail',
        columnWidth: 135,
        gutter: 12
      };
      $.extend(defaults, options);

      return this.each(function (e) {
        var o = defaults;

        $(this).append('<div class="thumbnail-wrapper"></div>');
        var $container = $(this).find('.thumbnail-wrapper');

        $container.masonry(o);
        $container.masonry('unbindResize');
      });
    },

    initThumb: function (options) {
      var defaults = {
        itemSelector: '.thumbnail',
        columnWidth: 135,
        gutter: 12
      };
      $.extend(defaults, options);

      var target = this;

      if (!$(target).is('.thumbnail-wrapper'))				{
        target = $(this).find('.thumbnail-wrapper');
      }

      return this.each(function (e) {
        var o = defaults;
        var $container = $(target);

        $container.masonry(o);
        $container.masonry('unbindResize');
      });
    },

    prependThumb: function (thumb, imageCheck, callback)		{
      var target = this;
      callback = callback || $.noop;

      return this.each(function (e) {
        if (imageCheck)				{
          target.prepend(thumb).imagesLoaded(function (e) {
            target.masonry();
            callback.call(this, thumb);
          });
        } else				{
          target.prepend(thumb).masonry('prepended', thumb);
          callback.call(this, thumb);
        }
      });
    },

    appendThumb: function (thumb, imageCheck, callback)		{
      var target = this;
      callback = callback || $.noop;

      return this.each(function (e) {
        if (imageCheck)				{
          target.append(thumb).imagesLoaded(function (e) {
            target.masonry();
            callback.call(this, thumb);
          });
        } else				{
          target.append(thumb).masonry('appended', thumb);
          callback.call(this, thumb);
        }
      });
    },

    reloadThumb: function (callback)		{
      var target = this;

      if (!$(target).hasClass('thumbnail-wrapper'))				{
        target = $(this).find('.thumbnail-wrapper');
      }
//			if(!image) image = false;

      return this.each(function (e) {
/*				if(imageCheck) {
					target.append(thumb).imagesLoaded(function(e) {
						target.masonry('reload');
						if(typeof callback == 'function') {
							callback.call(this);
						}
					});
				} else { */
        $(target).masonry();
        if (typeof callback === 'function') {
          callback.call(this);
        }
//				}
      });
    },

    removeThumb: function (thumb)		{
      var target = this;
      return this.each(function (e) {
        target.masonry('remove', thumb);
        target.masonry();
      });
    },

    isOnScreen: function () {
      if (!this.length) {
        return false;
      }
      var $window = $(window);

      var viewport = {
        top: $window.scrollTop(),
        left: $window.scrollLeft()
      };
      viewport.right = viewport.left + $window.width();
      viewport.bottom = viewport.top + $window.height();

      var bounds = this.offset();
      bounds.right = bounds.left + this.outerWidth();
      bounds.bottom = bounds.top + this.outerHeight();

      return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
    }
  });
})(jQuery);
